import styled, { keyframes } from 'styled-components';

const bounce = keyframes`
  0%, 60%, 100% {
    transform: translateY(0);
    opacity: 0.6;
  }
  30% {
    transform: translateY(-50%);
    opacity: 1;
  }
`;

export const DotsContainer = styled.span<{
  $gap: number;
  $duration: number;
}>`
  display: inline-flex;
  align-items: center;
  gap: ${({ $gap }) => $gap}em;
  margin-left: 0.4em;
  vertical-align: middle;
`;

export const Dot = styled.span<{
  $size: number;
  $delay: number;
  $duration: number;
}>`
  display: inline-block;
  width: ${({ $size }) => $size}em;
  height: ${({ $size }) => $size}em;
  border-radius: 50%;
  background-color: currentColor;
  animation: ${bounce} ${({ $duration }) => $duration}ms ease-in-out infinite;
  animation-delay: ${({ $delay }) => $delay}ms;
`;
